export default __webpack_public_path__ + "static/media/car-dimension.949b22f8.svg";